"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDatabaseStatusColumn = void 0;
/**
 * Similar to `parseTaskStatus` but for parsing a database column
 * to get status string after the last slash character (`/`).
 * @param columnName The column to parse that contains the Workflow status.
 * @returns An SQL statement of the parsed column.
 */
function parseDatabaseStatusColumn(columnName) {
    return `RIGHT(${columnName}, POSITION('/' IN REVERSE(${columnName})) - 1)`;
}
exports.parseDatabaseStatusColumn = parseDatabaseStatusColumn;
//# sourceMappingURL=parse-database-status-column.js.map